import * as React from "react";

type RemoteQueryCheckResultType = {
  remoteQueryChecked: boolean;
  remoteQuery: string | null;
};

export function useRemoteQuery(queryFile: string | null) {
  const [{ remoteQueryChecked, remoteQuery }, setResult] =
    React.useState<RemoteQueryCheckResultType>({
      remoteQueryChecked: false,
      remoteQuery: null,
    });

  React.useEffect(() => {
    if (queryFile) {
      fetch(queryFile)
        .then((res) => res.text())
        .then((data) => {
          setResult({ remoteQueryChecked: true, remoteQuery: data });
        })
        .catch(() =>
          setResult({
            remoteQueryChecked: true,
            remoteQuery: `"""Failed to fetch remote query from ${queryFile}"""\n`,
          })
        );
    } else setResult({ remoteQueryChecked: true, remoteQuery: null });
  }, [queryFile]);

  return { remoteQueryChecked, remoteQuery };
}
